export const S = window.com?.ts.mobile.sdk;